import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
import axios from 'axios'
import {apiAuth, apiAuthMe, apiLogout, refreshToken, apiMfAuth, connectWebSocket, beepSound}
  from '@/common/utils'
// import io from 'socket.io-client';
// import createPersistedState from "vuex-persistedstate";


const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  asideShow: false,
  darkMode: true,
  messageBarShow: false,
  messageBarMinimize: false,
  loginTimeStamp: 0,
  expireSecIn: 0,
  ccd: '',
  fromDays: 0,
  msgs: [],
  msgLength: 100,
  soundOn: false,
  isMsgLoaded: false,
  isAdwOn: false,
  isMsgOn: false,
  objectKey: '',
  voice: null, // 목소리
  adwMsgs: [],
  gval: {
    center: { map: {}, opts: [] },
    customer: { map: {}, opts: [] },
    fee: { map: {}, opts: [] },
    numOfRec : 10,
  },
  user: {
    id: null,
    nickName: null,
    name: null,
    role: null,
    centerCode: null,
    wgCode: null,
    tokenExpireMin: 0,
    accessToken: null,
    roleName: null,
    isAuth: false,
    mfAuth: false,
    bucketName: null,
    isAdmin: false,
  },
  socket: null
};


const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  async toggle (state, variable) {
    state[variable] = !state[variable];
    await beepSound('success')
  },
  set (state, [variable, value]) {
    console.log( 'store.set() --- register global variable ---', variable);
    state[variable] = value
  },
  // ------------ below --- added for application ------------
  get (state, key) {
    return state[key];
  },

  LOGIN(state, user) {
    state.user = user;
    localStorage.user = JSON.stringify(user);
    console.debug('save localStorage----user---', localStorage.user)
    axios.defaults.headers.common['Authorization'] = user.accessToken;
  },

  async setToken(state, auth) {
    console.log("========= store-mutation-setToken ========= ", auth);
    state.user.accessToken = auth.accessToken;
    state.loginTimeStamp = Date.now();
    state.user.tokenExpireMin = auth.tokenExpireMin;
    state.user.mfAuth = auth.mfAuth ? auth.mfAuth : false
    state.expireSecIn = (auth.tokenExpireMin * 60);
    axios.defaults.headers.common['Authorization'] = auth.accessToken;
    localStorage.user = JSON.stringify(state.user);

  },

  async LOGOUT(state) {
    console.log("========= store-mutation-LOGOUT ========= ");
    try {
      axios.defaults.headers.common['Authorization'] = null;
      delete localStorage.user;
      // state.user = cloneVar(_user);
      state.socket = null;
      state.isMsgLoaded = false;
    } catch (err) {
      console.log("========= store-mutation-LOGOUT ----->logout error--->", err);
    }
  },
};

export const rolesMap = {
  ROLE_SUPER_ADMIN: '수퍼 관리자', // 수퍼 관리자,
  ROLE_PORTAL_ADMIN: '포탈 관리자', //포탈 관리자,
  ROLE_PORTAL_MANAGER: '포탈 담당자', //
  ROLE_ADW_ADMIN: 'ADW 관리자', // ADW 관리자
  ROLE_ADW_MANAGER: 'ADW 담당자', // ADW 담당자
  ROLE_USER: 'ADW 사용자'
}

const actions = {
  async LOGIN({commit}, {username, password}) {
    const _log = '################ STORE_ACTIONS_LOGIN---';
    // console.log( "*** ------------------- store----action-----LOGIN -------------------- ***");

    const param = {
      username,
      password,
    };

    // const encodedParam = qs.stringify( param );
    // const serverUrl = $baseURL;
    try {
      const rs = await apiAuth(param);
      console.log(_log, "apiAuth result --->", rs);

      if (rs.token) {
        const accessToken = `Bearer ${rs.token}`;
        axios.defaults.headers.common['Authorization'] = accessToken;

        const {data} = await apiAuthMe();
        console.debug('me__________result________data___',data)
        const {user} = data;

        console.log(_log, "user__________________", user);

        const commitUser = {
          id: user.userId,
          nickName: user.displayName,
          name: user.username,
          role: user.userRole,
          centerCode: 'ADW',
          wgCode: 'ADW',
          tokenExpireMin: 60,
          accessToken: accessToken,
          roleName: rolesMap[user.userRole],
          isAuth: true,
          mfAuth: false,
          isAdmin: (user.userRole==='ROLE_ADW_ADMIN' || user.userRole==='ROLE_SUPER_ADMIN')
        };

        console.debug(_log, 'user--->', commitUser);

        await commit('LOGIN', commitUser);
      }

      return true;

    } catch (err) {
      console.log("################ STORE___ACTION___LOGIN error: ", err);
      return err.response.data;
      // throw err;
    }
  },

  async MFAuth({commit}, {authNumber}) {
    try {
      const rs = await apiMfAuth({authNumber});
      if (rs.code === 200) {
        await commit('setToken', rs.result); // mutation call
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.error(err);
      return false;
    }
  },

  async LOGOUT({commit}) {
    console.log('################ STORE_ACTION___LOGOUT ################');
    try {
      if (state.socket) {
        console.log("################ STORE_ACTION___LOGOUT-----> socket: ", state.socket);
        state.socket.removeAllListeners();
        state.socket.disconnect();
      }

      if (axios.defaults.headers.common['Authorization']) {
        const rs = await apiLogout();
        console.log("################ STORE_ACTION___LOGOUT ----->logout result--->", rs);
      }

      await commit('LOGOUT');

    } catch (err) {
      console.log("################ STORE_ACTION___LOGOUT Error:", err)
    } finally {
      axios.defaults.headers.common['Authorization'] = undefined;
    }

  },

  async refreshToken({commit}) {
    // console.log('################ STORE_ACTION___refreshToken ################');
    console.log('################ STORE_ACTION___refreshToken ################');
    const rs = await refreshToken();
    if (rs.code === 200) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${rs.result.accessToken}`;
      await commit('setToken', rs.result); // mutation call
      // await commit('LOGIN', rs.result); // mutation call
      return true;
    } else {
      return false;
    }
  },

  async setLoginState({commit}, {accessToken}) {
    const _log = '@@@@@@@@@@ setLoginState ---';
    console.warn(_log, accessToken);
    try {
      axios.defaults.headers.common['Authorization'] = accessToken;
      const {data} = await apiAuthMe();
      console.debug('me__________result________data___',data)
      const {user} = data;

      if (user) {
        state.loginTimeStamp = Date.now();
        state.expireSecIn = (user.tokenExpireMin * 60);

        const commitUser = {
          id: user.userId,
          nickName: user.displayName,
          name: user.username,
          role: user.userRole,
          centerCode: 'ADW',
          wgCode: 'ADW',
          tokenExpireMin: 60,
          accessToken: accessToken,
          roleName: rolesMap[user.userRole],
          isAuth: true,
          mfAuth: true,
          isAdmin: (user.userRole==='ROLE_ADW_ADMIN' || user.userRole==='ROLE_SUPER_ADMIN')
        };

        await connectWebSocket(commitUser.centerCode, accessToken);

        // await getGlobals();

        console.log('@@@@@@@@@@ setLoginState() ----> commit user---------->', commitUser);

        await commit('LOGIN', commitUser);
        return true;

      } else {
        commit('LOGOUT');
        return false;
      }
    } catch (err) {
      console.log("@@@@@@@@@@ setLoginState ------------> ", err.message);
      commit('LOGOUT');
      throw err;
    }
  }
};



export default new Vuex.Store({
  state,
  mutations,
  actions
})
